import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { getWhatsAppLink } from '../../utils/whatsapp';
const systems = [{
  key: 'presencia',
  label: 'PRESENCIA DIGITAL',
  title: 'Construye una presencia que convierta.',
  desc: 'Webs y experiencias digitales diseñadas para representar tu empresa y convertir visitantes en oportunidades.',
  price: 'Desde $3.500.000',
  priceNote: 'implementación',
  cta: 'Explorar',
  featured: false,
  whatsapp: 'Hola, equipo de Origen Studio. Quiero explorar el sistema de Presencia Digital para mi empresa.'
}, {
  key: 'comercial',
  label: 'SISTEMA COMERCIAL',
  badge: 'MÁS ELEGIDO',
  title: 'Automatiza lo que sucede después.',
  desc: 'IA + WhatsApp + CRM + agenda + seguimiento para convertir conversaciones en procesos comerciales.',
  price: 'Desde $2.500.000 + $650.000/mes',
  priceNote: '',
  cta: 'Explorar',
  featured: true,
  whatsapp: 'Hola, equipo de Origen Studio. Quiero explorar el Sistema Comercial para mi empresa.'
}, {
  key: 'completo',
  label: 'SISTEMA COMPLETO',
  badge: 'ORIGEN SYSTEM',
  title: 'Presencia + automatización. Un solo sistema.',
  desc: 'Construimos tu presencia digital y conectamos todo lo que sucede después de que alguien muestra interés.',
  price: 'Desde $6.000.000 + $900.000/mes',
  priceNote: '',
  cta: 'Construir mi sistema',
  featured: true,
  heaviest: true,
  whatsapp: 'Hola, equipo de Origen Studio. Quiero construir el Sistema Completo para mi empresa.'
}];
export function ThreeSystems() {
  return <section id="sistemas" className="bg-arena py-[72px] md:py-[120px]" data-id="element-206" data-mp="1nuklj13jfnsr">
      <div className="max-w-[1200px] mx-auto px-6 md:px-20" data-id="element-207" data-mp="1sw9tu8zdlnd5">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.4,
        ease: 'easeOut'
      }} className="mb-14 md:mb-16 text-center max-w-[600px] mx-auto" data-id="element-208" data-mp="2zbataonm0noh">
          <span className="block font-body text-[11px] uppercase font-medium text-salvia tracking-[0.15em] mb-4" data-id="element-209" data-mp="1d7svghvz7wr1">
            ¿QUÉ NECESITAS CONSTRUIR?
          </span>
          <h2 className="font-display text-[32px] md:text-[48px] font-bold text-carbon leading-[1.1]" data-id="element-210" data-mp="lhekatfckyj2">
            Un sistema que se adapte a tu empresa.
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 items-stretch" data-id="element-211" data-mp="u9ydhecveawi">
          {systems.map((system, idx) => <motion.div key={system.key} initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.4,
          ease: 'easeOut',
          delay: idx * 0.08
        }} className={`relative flex flex-col rounded-[12px] p-8 md:p-9 transition-all duration-200 ${system.heaviest ? 'bg-verde text-arena md:-translate-y-3 shadow-cta border border-verde md:scale-[1.03]' : 'bg-arena-dark text-carbon border border-salvia/25 hover:border-verde/50 hover:-translate-y-[2px] hover:shadow-card'}`} data-id="element-212" data-mp="piq60nv3ozlz" data-mpi={idx}>
              {system.badge && <span className={`absolute -top-3 left-8 font-body text-[11px] font-semibold uppercase tracking-[0.1em] px-3 py-1 rounded-full ${system.heaviest ? 'bg-azul text-arena' : 'bg-azul text-arena'}`} data-id="element-213" data-mp="3slbhn9sxknei">
                  {system.badge}
                </span>}
              <span className={`font-body text-[11px] uppercase tracking-[0.12em] mb-4 ${system.heaviest ? 'text-arena/60' : 'text-salvia'}`} data-id="element-214" data-mp="32e8934q3k0za">
                {system.label}
              </span>
              <h3 className={`font-display text-[22px] font-bold mb-3 leading-[1.2] ${system.heaviest ? 'text-arena' : 'text-carbon'}`} data-id="element-215" data-mp="2skrdbv6egbsz">
                {system.title}
              </h3>
              <p className={`font-body text-[14px] leading-[1.6] mb-6 flex-grow ${system.heaviest ? 'text-arena/80' : 'text-carbon/65'}`} data-id="element-216" data-mp="3gcy8ir0e2cqt">
                {system.desc}
              </p>
              <div className={`h-px w-full mb-5 ${system.heaviest ? 'bg-arena/20' : 'bg-carbon/10'}`} data-id="element-217" data-mp="36fa8pmnxef1s" />
              <div className="mb-6" data-id="element-218" data-mp="1zzq5qvasgsvy">
                <span className={`font-display text-[18px] font-bold ${system.heaviest ? 'text-arena' : 'text-carbon'}`} data-id="element-219" data-mp="1uzbz9hou5r01">
                  {system.price}
                </span>
                {system.priceNote && <span className={`font-body text-[13px] ml-1.5 ${system.heaviest ? 'text-arena/60' : 'text-carbon/50'}`} data-id="element-220" data-mp="fgxglectxa95">
                    {system.priceNote}
                  </span>}
              </div>
              <a href={getWhatsAppLink(system.whatsapp)} target="_blank" rel="noopener noreferrer" className={`inline-flex items-center justify-center font-display font-semibold text-[14px] px-6 py-3.5 rounded-[6px] transition-all duration-200 ${system.heaviest ? 'bg-arena text-verde hover:bg-[#EAE7E0]' : 'bg-verde text-arena hover:bg-verde-hover hover:-translate-y-[1px] hover:shadow-cta'}`} data-id="element-221" data-mp="u5tqlgyg4xce">
                {system.cta} <ArrowRight size={15} className="ml-1.5" data-id="element-222" data-mp="39y9e28s79xem" />
              </a>
            </motion.div>)}
        </div>
      </div>
    </section>;
}